import { formatDate } from "../../../../../api/DateUtils";
import { Column } from "react-table";
import { Grid } from "../../../../../leap-components/Grid";
import { SelectColumnFilter } from "../../../../../leap-components/Grid/NoFetchGrid/SelectColumnFilter";
import { GetFilteredDocumentsFetchUrl } from "../../../../../api/CircularEconomy/INotifiers";
import EpaCard from "../../../../../leap-components/EpaCard";
import { Link } from "react-router-dom";

interface ISearchResultRow {
  document_id: string;
  notifier_id: string;
  document_name: string;
  created_by: string;
  date: string;
  document_url: string;
  classification: string;
  category: string;
}

interface DocumentsGridProps {
  NotifierId: string;
}

const DocumentsGrid = ({ NotifierId }: DocumentsGridProps) => {
  const getFetchUrlFactory = (NotifierId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetFilteredDocumentsFetchUrl(
        NotifierId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(NotifierId);

  const tableColumnsBig: Column<Record<string, ISearchResultRow>>[] = [
    {
      Header: "Date",
      accessor: "documentdate",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Created By",
      accessor: "createdby",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Category",
      accessor: "classification",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Subcategory",
      accessor: "subclassification",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Document Name",
      accessor: "filename",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return <a href={rowData.url}>{rowInfo.value}</a>;
      },
      sortType: "basic",
    },
  ];

  const tableColumnsSmall: Column<Record<string, ISearchResultRow>>[] = [
    {
      Header: "Date",
      accessor: "documentdate",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Created By",
      accessor: "createdby",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Category",
      accessor: "classification",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Subcategory",
      accessor: "subclassification",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Document Name",
      accessor: "filename",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return <Link to={rowData.url}>{rowInfo.value}</Link>;
      },
      sortType: "basic",
    },
  ];

  var bodyElements = (
    <div className="ps-0">
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={false}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={false}
        />
      </div>
    </div>
  );

  return <EpaCard title={"Documents"} content={bodyElements} />;
};

export { DocumentsGrid };
